import { NgModule } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { ChatbotComponent } from './chatbot.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChatbotChatInputComponent } from './chatbot-chat-input/chatbot-chat-input.component';
import { DsrIconsModule } from '@desyre/icons-angular';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatButton, MatButtonModule, MatFabButton, MatIconButton } from '@angular/material/button';
import { ChatbotCollapseButtonComponent } from './chatbot-collapse-button/chatbot-collapse-button.component';
import { ChatbotHeaderComponent } from './chatbot-header/chatbot-header.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ContactModule } from '../contact/contact.module';

@NgModule({
  declarations: [
    ChatbotComponent,
    ChatbotChatInputComponent,
    ChatbotCollapseButtonComponent,
    ChatbotHeaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule, 
    MatButtonModule, 
    MatMenuModule, 
    MatInputModule, 
    DsrIconsModule, 
    MatFabButton,
    MatIconButton, 
    MatButton,
    MatSidenavModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    NgClass,
    TranslateModule,
    ContactModule
  ],
  exports: [
    ChatbotComponent,
    ChatbotChatInputComponent,
    ChatbotCollapseButtonComponent,
    ChatbotHeaderComponent
  ]
})

export class ChatbotModule { }